import {connect} from '../../../../redux/utils'
import {showEditor} from '../selectors'
import {bindActionCreators} from 'redux'
import HierarchyAssignmentsEditorPanel from '../../components/hierarchyAssignmentsEditor/HierarchyAssignmentsEditorPanel'
import WorkAssignmentsEditor from './WorkAssignmentsEditor'
import {PANEL_TYPES} from '../../../../panels/constants'
import {setEventPreventHidingWorkAssignmentSlidingPanel} from '../../../../panels/utils'
import {closeAllPanels} from '../../common/actions'
import {closeEditor} from "../actions";

export class WorkAssignmentsEditorPanel extends HierarchyAssignmentsEditorPanel {
    constructor(params) {
        super({
            hierarchyAssignmentsEditor: new WorkAssignmentsEditor(),
            extraClass: 'userManagement_workAssignmentsEditorPanel',
            panelType: PANEL_TYPES.WORK_ASSIGNMENTS_EDITOR,
            onClickContent: e => setEventPreventHidingWorkAssignmentSlidingPanel(e),
            ...params
        })
    }
}

export default connect(
    state => ({
        show: showEditor(state)
    }),
    dispatch => ({
        closeEditor: bindActionCreators(closeEditor, dispatch),
        closeAllPanels: bindActionCreators(closeAllPanels, dispatch)
    })
)(WorkAssignmentsEditorPanel)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsEditor/components/WorkAssignmentsEditorPanel.js